// extracted by mini-css-extract-plugin
module.exports = {"rewards":"Rewards_rewards__x0kIY"};